'use strict';
const { publicDataPlan } = require('./publicSeoRoutes');
const NECESSARY_WEBSITE_EVENTS = Object.freeze(['listing.viewed','claim.started','search.performed','user.consent.changed']);
const SEARCH_HOSTS = new Set(['google.com','www.google.com','google.co.uk','www.google.co.uk','google.ca','www.google.ca','google.com.au','www.google.com.au','bing.com','www.bing.com','search.yahoo.com','duckduckgo.com','www.duckduckgo.com','search.brave.com','www.ecosia.org','ecosia.org']);
const CHANNELS = Object.freeze(['unattributed','direct_or_unknown','internal','search_referral','external_referral','tagged_campaign','paid_tag']);
function websiteEventContext({ pageUrl, referrer, canonicalOrigin, analyticsConsent = false, paidTag = false, taggedCampaign = false } = {}) {
  if (typeof pageUrl !== 'string' || pageUrl.length > 2048 || /[\\\r\n\0]/.test(pageUrl)) return null;
  let url;
  try { url = new URL(pageUrl); } catch { return null; }
  if (!['http:','https:'].includes(url.protocol) || url.origin !== canonicalOrigin || url.username || url.password) return null;
  const plan = publicDataPlan(`${url.pathname}${url.search}`);
  if (!plan || plan.invalidQuery) return null;
  const path = url.pathname.replace(/\/+$/, '') || '/';
  if (path.length > 1024) return null;
  let channel = 'unattributed', referrerHost = null;
  if (analyticsConsent === true) {
    channel = 'direct_or_unknown';
    if (typeof referrer === 'string' && referrer.length <= 2048) {
      try {
        const source = new URL(referrer);
        if (['http:','https:'].includes(source.protocol) && !source.username && !source.password && !source.port && source.hostname.length <= 253 && source.hostname.includes('.') && !/^[\d.]+$/.test(source.hostname)) {
          referrerHost = source.hostname;
          channel = source.origin === canonicalOrigin ? 'internal' : SEARCH_HOSTS.has(source.hostname) ? 'search_referral' : 'external_referral';
        }
      } catch { /* Missing/invalid referrers do not establish a source. */ }
    }
    const medium = (url.searchParams.get('utm_medium') || '').toLowerCase();
    if (paidTag === true || ['cpc','ppc','paid','paid_search','paid_social','display'].includes(medium) || ['gclid','dclid','msclkid'].some(key => url.searchParams.has(key))) channel = 'paid_tag';
    else if (taggedCampaign === true || ['utm_source','utm_medium','utm_campaign'].some(key => url.searchParams.has(key))) channel = 'tagged_campaign';
  }
  return { version: 1, analyticsConsent: analyticsConsent === true, path, pageType: plan.kind === 'home' ? 'homepage' : plan.kind, channel, referrerHost };
}
module.exports = { websiteEventContext, NECESSARY_WEBSITE_EVENTS, CHANNELS };
